// Styles
import { useSuiteNavLoadingPlaceHolderStyles } from "./SuiteNavLoadingPlaceHolder.styles";
// Utilities
import * as React from "react";
/**
 * Suite nav place holder while loading lazy loaded suite nav container
 */ export const SuiteNavLoadingPlaceHolder = ()=>{
    const styles = useSuiteNavLoadingPlaceHolderStyles();
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.root
    });
};
